import request from '@/utils/request'

export function listAllCate() {
  return request({
    url: '/ums/resourceCategory/listAll',
    method: 'get'
  })
}

export function createResourceCategory(data) {
  return request({
    url: '/ums/resourceCategory/create',
    method: 'post',
    data: data
  })
}

export function updateResourceCategory(id, data) {
  return request({
    url: '/ums/resourceCategory/update/' + id,
    method: 'post',
    data: data
  })
}

export function deleteResourceCategory(id) {
  return request({
    url: '/ums/resourceCategory/delete/' + id,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/resourceCategory.js